import { DialogContent, styled } from '@mui/material'
import React from 'react'

import { COLORS, createComponentWrapperWithRef, uiTokens } from '../../../theme'
import { E2eTag } from '../../../utils'
import { Dialog, DialogActions, DialogTitle } from '../../Dialog'

interface ModalProps {
  id: string
  body?: React.ReactNode
  disableOutsidePointerEvents?: boolean
  preventEscapeFromClosing?: boolean
  footer?: React.ReactNode
  headerTitle?: string
  isOpen?: boolean
  width?: string
  height?: string
  isFullScreen?: boolean
  onDismiss?: () => void
}

const BaseHidingDialog = styled(Dialog)`
  .MuiDialog-paper {
    background-color: ${COLORS.components.modal.background};
  }
  &:has(.MuiDialogContent-root > .dynamic-form-hidden) {
    .MuiPaper-elevation,
    .MuiDialogContent-root {
      display: none;
    }
  }
`

const HidingDialog = createComponentWrapperWithRef(
  {
    mui: BaseHidingDialog,
    nova: styled(BaseHidingDialog)`
      .MuiDialog-paper {
        padding: 0;
        background-color: ${uiTokens.uiSurface['wm-static']};

        .modal-tabs-content {
          padding: 0;
        }
      }
    `,
  },
  'HidingDialog',
)

export const ModalBase = ({
  body,
  footer,
  headerTitle,
  isOpen,
  onDismiss,
  width,
  height,
  isFullScreen,
  disableOutsidePointerEvents,
  preventEscapeFromClosing,
  ...props
}: ModalProps & E2eTag) => {
  const handleOverlayDismiss = (e: any, reason: string) => {
    e.stopPropagation()
    e.preventDefault()
    if (!disableOutsidePointerEvents || (disableOutsidePointerEvents === true && reason !== 'backdropClick'))
      onDismiss?.()
  }

  const isFullSize = isFullScreen || (height === '100dvh' && width === '100dvw')
  const paperProps = isFullSize
    ? {
        sx: {
          width,
          height,
          borderRadius: 0,
          margin: 0,
          maxHeight: 'unset',
        },
      }
    : {
        sx: {
          width,
          height,
        },
      }

  return (
    <>
      {isOpen && (
        <HidingDialog
          PaperProps={paperProps}
          id={props.id}
          open={isOpen}
          onClose={handleOverlayDismiss}
          disableEnforceFocus={true}
          disableEscapeKeyDown={preventEscapeFromClosing}
        >
          {headerTitle !== undefined && <DialogTitle data-test-id="modal-header">{headerTitle}</DialogTitle>}
          <DialogContent sx={{ overflowY: 'auto', padding: isFullSize ? 0 : undefined }} data-test-id="body">
            {body}
          </DialogContent>
          {footer !== undefined && <DialogActions data-test-id="footer">{footer}</DialogActions>}
        </HidingDialog>
      )}
    </>
  )
}
